import { EmployeeModel, EmployeePromotionModel } from 'api-hooks/employee';
import { GenderTypeEnum } from 'common/constants/enum';
import { PreferenceFormSchema } from 'common/form-schema';
import * as Yup from 'yup';

export const EmployeeFormSchema = () =>
  Yup.object({
    joinedAt: Yup.date().nullable().default(null),
    name: Yup.string().default(''),
    password: Yup.string().default(''),
    passwordConfirmation: Yup.string().default(''),
    username: Yup.string().default(''),
    code: Yup.string().default(''),
    gender: Yup.string().default(GenderTypeEnum.Male),
    roles: Yup.array(PreferenceFormSchema()).default([]),
    address: Yup.string().default(''),
    phone: Yup.string().default(''),
    phone_2: Yup.string().default(''),
    jobLevel: Yup.string().default(''),
  });

export const EmployeePromotionFormSchema = () =>
  Yup.object({
    jobLevel: Yup.string().default(''),
    promotedAt: Yup.date().default(new Date()),
  });

export type EmployeeFormType = Yup.InferType<
  ReturnType<typeof EmployeeFormSchema>
> & {
  employee?: EmployeeModel;
};

export type EmployeePromotionFormType = Yup.InferType<
  ReturnType<typeof EmployeePromotionFormSchema>
> & {
  promotion?: EmployeePromotionModel;
};
